"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
require("./Toast.css");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@tiendanube/icons");
var __1 = require("..");
function Toast(_a) {
    var label = _a.label, _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, onClose = _a.onClose;
    var iconVariants = {
        primary: icons_1.InfoCircleIcon,
        secondary: icons_1.InfoCircleIcon,
        danger: icons_1.ExclamationTriangleIcon,
        success: icons_1.CheckCircleIcon,
        warning: icons_1.ExclamationCircleIcon,
    };
    var Icon = iconVariants[appearance];
    var _c = React.useState(false), show = _c[0], setShow = _c[1];
    var wrapperClassName = (0, classnames_1.default)("nimbus--toast-wrapper", {
        "is--visible": show,
    });
    var className = (0, classnames_1.default)("nimbus--toast", "nimbus--toast--".concat(appearance), appearance);
    var container = React.useMemo(function () { return document.createElement("div"); }, []);
    var time = React.useRef();
    React.useEffect(function () {
        document.body.appendChild(container);
        return function () {
            document.body.removeChild(container);
        };
    }, [container]);
    React.useEffect(function () {
        setTimeout(function () { return setShow(true); }, 10);
        time.current = window.setTimeout(function () {
            setShow(false);
            setTimeout(function () { return onClose(); }, 200);
        }, 4000);
        return function () {
            clearTimeout(time.current);
        };
    }, [onClose]);
    var element = (React.createElement("div", { className: wrapperClassName },
        React.createElement("div", { className: className },
            React.createElement(Icon, null),
            React.createElement(__1.Text, { size: "caption" }, label))));
    return ReactDOM.createPortal(element, container);
}
exports.default = Toast;
//# sourceMappingURL=index.js.map